export default __webpack_public_path__ + "static/1_33-77d3e340366ddc7c3986080768d2ca32.png";